export default __webpack_public_path__ + "plus-icon.8e449337b6842f7b057d10293daf9b52.svg";